import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {IntegrationPartnerSearchModel} from "../integration-partner-search.model";

@Component({
    selector: "wbo-integration-partner-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(IntegrationPartnerSingleSelectEditControlComponent),
        provideSearchModel(IntegrationPartnerSearchModel)
    ]
})
export class IntegrationPartnerSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<IntegrationPartnerSearchModel> {

    constructor(model: IntegrationPartnerSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
    }

}
